import { render, staticRenderFns } from "./PracticeAdmin.vue?vue&type=template&id=36110f2c&"
import script from "./PracticeAdmin.vue?vue&type=script&lang=js&"
export * from "./PracticeAdmin.vue?vue&type=script&lang=js&"
import style0 from "./PracticeAdmin.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports